import { useEffect, useState } from 'react';

const getIsMobileByWidth = (breakpoint) => {
  if (typeof window === 'undefined') {
    return false;
  }
//return  true;
  return window.innerWidth <= breakpoint;

};

const useIsMobile = (breakpoint = 992) => {
  const [isMobile, setIsMobile] = useState(() => getIsMobileByWidth(breakpoint));

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobileByWidth(breakpoint));
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
